import { render, staticRenderFns } from "./AddEditTabInformation.vue?vue&type=template&id=668b39ac"
import script from "./AddEditTabInformation.vue?vue&type=script&lang=js"
export * from "./AddEditTabInformation.vue?vue&type=script&lang=js"
import style0 from "./AddEditTabInformation.vue?vue&type=style&index=0&id=668b39ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports